import React, { useEffect } from 'react';
import classNames from 'classnames/bind';

import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { initializeBlogPagesIfNeeded } from '../../state/modules/page/actions';
import Heading from '../Heading';


import styles from './BlogMainPage.styl';
import BlogSlider from './partial/BlogSlider';

const cx = classNames.bind(styles);

export default function BlogMainPage() {

  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeBlogPagesIfNeeded());
  }, []);


  return (
    <div className={cx('BlogMainPage')}>
      <Heading className={cx('BlogMainPage__heading')} level={4}>
        {intl.formatMessage({ id: 'blog.title' })}
      </Heading>
      <BlogSlider />
    </div>
  );
}

